import { z } from "zod";

export const passwordResetSchemaOne = z.object({
    email: z
        .email({
            message: "A valid email address is required",
        })
        .min(1, {
            message: "Email is required",
        }),
});

export const passwordResetSchemaTwo = z.object({
    verificationToken: z
        .string({
            message: "Token is required",
        })
        .min(1, {
            message: "Token is required",
        })
        .min(8, {
            message: "Token must be 8 characters long",
        })
        .max(8, {
            message: "Token must be 8 characters long",
        }),
    password: z
        .string({
            message: "Password is required",
        })
        .min(8, {
            message: "Password must be at least 8 characters long",
        })
        .regex(/[A-Z]/, {
            message: "Password must contain at least one uppercase letter",
        })
        .regex(/[a-z]/, {
            message: "Password must contain at least one lowercase letter",
        })
        .regex(/[0-9!@#$%^&*(),.?":{}|<>]/, {
            message:
                "Password must contain at least one number or special character",
        }),
});
